/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SuspectedTradeUserLoader_item$ref = any;
export type SuspectedTradeUserLoader_item = {
    readonly vertical: VerticalType | null;
    readonly " $refType": SuspectedTradeUserLoader_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SuspectedTradeUserLoader_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "vertical",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'e0429a3bc313f2074497a94adccd3cac';
export default node;
